import React from 'react'
import './Testimonials.scss';
import ReactPlayer from 'react-player'

// import video from '../../Images/familvideo.mp4'

function Testimonials() {
    return (
        <div>
            <div id='testimonials'>
                <div className='quoteContainer'>
                    <h1>Testimonials</h1>
                    <div className='row'>
                        <div className='col-lg testimonialCard'>
                            <h2>“[These Afghan Partners] played a very important role in the effort to go after the most significant terrorists...”</h2>
                            <p>- Former CIA Director Gen. David Petraeus</p>
                        </div>
                        <div className='col-lg mvSpacing testimonialCard'>
                            <h2>“Their commitment to two nations, ours and Afghanistan, was unmatched among the joint forces in almost 20 years of continuous combat. They never wavered. Countless Americans and Afghans are alive today due to their fidelity.”</h2>
                            <p>- Mike Barry, Retired senior CIA officer and former Chief of Station</p>
                        </div>
                        <div className='col-lg testimonialCard'>
                             <h2>“They served alongside U.S. troops for two decades. They risked their lives to protect American lives.”</h2>
                            <p>- LTG John F. Mulholland (USA, Ret)</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Testimonials
